import { Box, Button, TextField, Typography } from '@mui/material';
import { useState } from 'react';
import { postVesselListMyFleet } from '../../../api/admin/vessel-lists';
import { useAppSelector } from '../../../hooks';
import FormStatusWrapper from '../../form-messages/form-status-wrapper';
import './add-list-modal.scss';

interface AddVesselListModalContentsProps {
  companyId: string;
  onCancel: () => void;
  onCreateSuccess: () => void;
}

function AddVesselListModalContents(props: AddVesselListModalContentsProps) {
  const { companyId, onCancel, onCreateSuccess } = props;
  const [vesselListName, setVesselListName] = useState('');

  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<boolean>(false);
  const [success, setSuccess] = useState<boolean>(false);

  const userInfo = useAppSelector((state) => state.user);
  const userCompanyId = userInfo.idToken?.companyId;

  const onCreate = () => {
    setLoading(true);

    const companyIdToInsert = companyId || userCompanyId;
    const postRequest = postVesselListMyFleet(
      vesselListName,
      companyIdToInsert
    );

    postRequest
      .then(() => {
        setSuccess(true);
        onCreateSuccess();
      })
      .catch(() => {
        setError(true);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', marginTop: '0.5em' }}>
      <FormStatusWrapper
        loading={loading}
        loadingMessage="Creating list..."
        error={error}
        errorMessage="Error creating list"
        success={success}
        successMessage="Successfully created list"
      >
        <Typography
          id="modal-modal-description"
          sx={{ mt: 2, mb: '1rem' }}
          color="text.primary"
        >
          Please enter the name of the List you wish to create:
        </Typography>
        <TextField
          required
          error={vesselListName === ''}
          value={vesselListName}
          onChange={(e) => setVesselListName(e.target.value)}
          id="new-vessel-list-name"
          label="List name"
          variant="outlined"
          sx={{
            mb: '4rem',
          }}
        />
      </FormStatusWrapper>

      <Box
        sx={{
          display: 'flex',
          justifyContent: 'right',
        }}
      >
        <Button
          variant="outlined"
          onClick={onCancel}
          sx={{
            m: '1rem 1.5rem',
            width: '74px',
          }}
        >
          {success || error ? 'Close' : 'Cancel'}
        </Button>
        {!loading && !error && !success && (
          <Button
            variant="contained"
            disabled={vesselListName.trim() === ''}
            onClick={onCreate}
            sx={{
              m: '1rem 1.5rem',
              width: '74px',
            }}
          >
            Create
          </Button>
        )}
      </Box>
    </Box>
  );
}

export default AddVesselListModalContents;
